export enum EAccountStatus {
    Inactive = 0,
    Active = 1,
    Pending = 10,
    Trial = 20,
    Deleted = 100
}

const AccountStatusLabels = new Map<EAccountStatus, string>();
AccountStatusLabels.set(EAccountStatus.Inactive, 'Inactive');
AccountStatusLabels.set(EAccountStatus.Active, 'Active');
AccountStatusLabels.set(EAccountStatus.Trial, 'Trial');
AccountStatusLabels.set(EAccountStatus.Pending, 'Pending');
AccountStatusLabels.set(EAccountStatus.Deleted, 'Deleted');

export interface AccountStatus {
    id: number;
    name: string | undefined;
}

export { AccountStatusLabels };
